import { Box } from '@mui/material';
import { useRef } from 'react';

import useOutsideClick from 'app/hooks/useOutsideClick';

function ContainedSideDrawer(props) {
  const { open, children, handleDrawerClose } = props;

  const wrapperRef = useRef(null);
  useOutsideClick(wrapperRef, handleDrawerClose);

  // The container spans the full width so the panel can slide in from the right, but
  // only the panel itself should capture clicks — otherwise the transparent area sits
  // over the content behind and swallows its clicks.
  const drawerClasses = `absolute top-0 right-0 bottom-0 z-999 flex justify-end transition-[width] vtwo:pointer-events-none ${
    open ? 'w-full' : 'w-0'
  }`;

  return (
    <Box className={`${drawerClasses}`}>
      {open && (
        <Box
          ref={wrapperRef}
          className="h-full bg-white border-l-2 border-l-grey-20 flex flex-col w-[70%] sm:w-full md:w-full lg:w-[75%] vtwo:pointer-events-auto"
        >
          {children}
        </Box>
      )}
    </Box>
  );
}

export default ContainedSideDrawer;
